export enum SystemStatus {
	PENDING = "PENDING",
	SUCCEEDED = "SUCCEEDED",
	CANCELLED = "CANCELLED",
}
